import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  noteText: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary
  }
}));

export const CostOverridesNote = () => {
  const classes = useStyles();

  return (
    <Typography
      variant="body2"
      className={classes.noteText}
      data-qe-id="ProjectCostOverridesDialogNoteText"
    >
      <strong>
        <FormattedMessage id="projectCostOverrides.dialog.note" />
      </strong>
      <FormattedMessage id="projectCostOverrides.dialog.noteText" />
    </Typography>
  );
};

export default CostOverridesNote;
